import gql from 'graphql-tag';

/** 优惠换购 */
export const PURCHASE_PREMIUM_FRAGMENT = gql`
  fragment PurchasePremium on PurchasePremium {
    __typename
    id
    name
    validityPeriod {
      type
      startTime
      endTime
      numberOfDays
    }
    state
    minimum
    applicableProduct {
      applicableType
      productIds
    }
    purchasePremiumProducts {
      id
      price
      enabled
      product {
        id
        name
        enabled
        optionGroups {
          id
          code
          name
          customFields {
            priority
          }
          options {
            id
            code
            name
            customFields {
              priority
            }
          }
        }
        variants {
          id
          name
          options {
            code
            name
            id
            group {
              id
              code
              name
            }
          }
          featuredAsset {
            source
          }
          isThereAnyStock
          price
          sku
        }
        featuredAsset {
          source
        }
        customFields {
          price
          markingPrice
        }
      }
    }
    activitySynopsis
    introduce
    activityContent
    activitySuperposition
    promotion {
      id
    }
  }
`;

export const DISCOUNT_ACTIVITY_FRAGMENT = gql`
  fragment DiscountActivity on DiscountActivity {
    __typename
    id
    name
    createdAt
    updatedAt
    remarks
    status
    startTime
    endTime
    minimum
    introduce
    discount
    productIds
    smallProgramQRCodeLink
    activityContent
    activitySynopsis
    activitySuperposition
    promotion {
      id
    }
  }
`;

export const FULL_DISCOUNT_PRESENT_FRAGMENT = gql`
  fragment FullDiscountPresent on FullDiscountPresent {
    __typename
    id
    name
    createdAt
    updatedAt
    remarks
    status
    startTime
    endTime
    fullDiscountType: type
    introduce
    ruleType
    fullDiscountType: type
    ruleValues {
      minimum
      discountValue {
        discountType
        discount
      }
      freeGiftValues {
        freeGiftId
        maximumOffer
      }
      maximumOffer
    }
    applicableProduct {
      applicableType
      productIds
    }
    fullDiscountContent: activityContent {
      fullMinus
      fullDiscount
      fullPresent
    }
    fullDiscountActivitySynopsis: activitySynopsis {
      synopsisStr
      synopsisTags
    }
    activitySuperposition
    promotion {
      id
    }
    activityGifts {
      id
      name
      description
      enabled
      variants {
        id
        name
        options {
          code
          name
          id
          group {
            id
            code
            name
          }
        }
        featuredAsset {
          id
          preview
          source
        }
        isThereAnyStock
        price
        priceWithTax
        sku
      }
      featuredAsset {
        id
        width
        height
        name
        preview
        source
        type
      }
      customFields {
        price
        markingPrice
        unit
        limitType
        limitCount
        putOnSaleType
        putOnSaleTime
        isVipProduct
      }
    }
  }
`;

export const PACKAGE_DISCOUNT_FRAGMENT = gql`
  fragment PackageDiscount on PackageDiscount {
    __typename
    id
    createdAt
    updatedAt
    name
    displayName
    remarks
    status
    startTime
    endTime
    price
    selectCount
    productIds
    activitySynopsis
    activityContentType: activityContent
    promotion {
      id
    }
    activitySuperposition
    statisticsData {
      totalPayment
      totalOrders
      customerCount
      averageOrderValue
    }
  }
`;

export const SELECTIVE_GIFT_ACTIVITY_FRAGMENT = gql`
  fragment SelectiveGiftActivity on SelectiveGiftActivity {
    __typename
    id
    createdAt
    updatedAt
    displayName
    name
    selectiveGiftActivityType: type
    remarks
    status
    startTime
    endTime
    introduce
    ruleType
    ruleValues {
      minimum
      discountValue {
        discountType
        discount
      }
      freeGiftValues {
        freeGiftId
        maximumOffer
      }
      maximumOffer
    }
    applicableProduct {
      applicableType
      productIds
    }
    promotion {
      id
    }
    activityContent
    activitySynopsis
    activitySuperposition
    activityGifts {
      id
      name
      enabled
      variants {
        id
        name
        options {
          code
          name
          id
          group {
            id
            code
            name
          }
        }
        featuredAsset {
          source
        }
        isThereAnyStock
        price
        sku
      }
      featuredAsset {
        source
      }
      customFields {
        price
        markingPrice
        isVipProduct
      }
    }
  }
`;

export const SHOPPING_CREDITS_CLAIM_ACTIVITY_FRAGMENT = gql`
  fragment ShoppingCreditsClaimActivity on ShoppingCreditsClaimActivity {
    __typename
    id
    createdAt
    updatedAt
    name
    remarks
    displayName
    status
    startTime
    endTime
    introduce
    ruleType
    shoppingCreditConditionType: type
    shoppingCreditsClaimActivityRuleValues: ruleValues {
      minimum
      discountValue {
        discountType
        discount
      }
      freeGiftValues {
        freeGiftId
        maximumOffer
      }
      maximumOffer
    }
    applicableProduct {
      applicableType
      productIds
    }
    smallProgramQRCodeLink
    promotion {
      id
    }
    activityContent
    shoppingCreditsClaimActivitySynopsis: activitySynopsis {
      synopsisStr
      synopsisTags
    }
    activitySuperposition
  }
`;

export const SHOPPING_CREDITS_DEDUCTION_ACTIVITY_FRAGMENT = gql`
  fragment ShoppingCreditsDeductionActivity on ShoppingCreditsDeductionActivity {
    __typename
    id
    createdAt
    updatedAt
    name
    remarks
    displayName
    status
    startTime
    endTime
    introduce
    minimum
    deductionRate
    applicableProduct {
      applicableType
      productIds
    }
    smallProgramQRCodeLink
    promotion {
      id
    }
    activityContent
    activitySynopsis
    activitySuperposition
  }
`;
